import { useTranslation } from 'react-i18next';
import { ConvergeButton } from '../../../presentation';
import {
  useQuoteListActionsContext,
  useQuoteListDispatchContext,
} from './quote-list.context';
import { useCallback } from 'react';

export const UnderwritingSortQuoteButton = () => {
  const { t } = useTranslation();
  const dispatch = useQuoteListDispatchContext();
  const actions = useQuoteListActionsContext();
  const handleClick = useCallback(() => {
    dispatch(actions.toggleSortQuoteModel(true));
  }, [dispatch, actions]);

  return (
    <ConvergeButton
      label={t('underwriting.quote.footer.sort-button', 'Sort quotes')}
      onClick={() => handleClick()}
    />
  );
};
